import InputSearch from "ui/components/Input/InputSearch";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
}

function HeaderTable({ onSearch, value }: HeaderTableProps) {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ flex: 1 }}>
        <InputSearch
          defaultValue={value}
          onSearch={(v) => onSearch(v)}
          placeholder="Pesquisar por unidade ou nome do morador..."
          maxW="400px"
        />
      </div>
    </div>
  );
}

export default HeaderTable;
